<template>
  <div class="game_room">
    <!-- 头部 -->
    <div class="header">
      <div class="header_bg"></div>
      <div class="bg_img">
        <img :src="bgUrl" alt>
        <div class="logo_image">
          <img class="logo" src="../assets/images/gameinviteRoom/assets/logo.png">
        </div>
        <div class="drama">
          <p class="subtitle">{{ dramaLabel }}</p>
          <div class="infos">
            <!-- 星星列表 -->
            <div class="infos_stars">
              <div class="stars" v-for="(star, index) in starIcons" :key="index">
                <img class="star" :src="star">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cover_img">
      <img :src="coverUrl" alt>
    </div>
    <div class="content_info">
      <div class="name">
        <p>{{ dramaName }}</p>
      </div>
      <div class="room_num">
        <p>房间号：{{ num }}</p>
      </div>
    </div>
    <div class="content_brief">
      <p> {{ briefIntroduction }}</p>
    </div>
    <p class="avatar">
      <img :src="avatar" alt>
    </p>
    <div class="nick_name">
      <p class="name">{{ nickname }}</p>
      <p class="invite_info">邀请你参与破案</p>
    </div>

    <div class="btn">
      <div class="btns_bottom" @click="join"></div>
      <img class="btn_img" src="../assets/images/gameinviteRoom/assets/btn.png" alt>
    </div>
    <!-- 引入模态组件 -->
    <Appopen :title="'我是谜app打开方式'" :browser="'1.' + '点击右上角[...]'" :direct="'2. ' + '选择[在浏览器中打开]'" :isAppopen="isAppopen">
    </Appopen>
  </div>
</template>

<script>
import { appUrlAndroid, appUrlIOS } from "../assets/js/base64"
import StarLight from "../assets/images/gameinviteRoom/assets/all_star_p_pic.png";
import StarHalf from "../assets/images/gameinviteRoom/assets/all_star_pn_pic.png";
import StarGray from "../assets/images/gameinviteRoom/assets/all_star_n_pic.png";
import axios from "axios";
export default {
  data() {
    return {
      bgUrl: "",
      briefIntroduction: "",
      coverUrl: "",
      dramaLabel: "",
      dramaName: "",
      dramaScore: "",
      nickname: "",
      avatar: "",
      dramaScore: "",
      starIcons: null,
      isAppopen: false
    };
  },
  components: {
    Appopen: () => import("../component/Appopen.vue")
  },
  created() {
    this.dramaid = this.$route.query.dramaId;
    this.userid = this.$route.query.id;
    this.num = this.$route.query.num;
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    document.getElementsByTagName('title')[0].innerText = '我是谜'
    axios({
      url: this.$interfaces.inviteRoom,
      method: "post",
      data: {
        dramaid: this.dramaid,
        id: this.userid
      },
      dataType: "json"
    })
      .then(res => {
        this.bgUrl = res.data.data.drama.bgUrl;
        this.coverUrl = res.data.data.drama.coverUrl;
        this.briefIntroduction = res.data.data.drama.briefIntroduction;
        this.dramaLabel = res.data.data.drama.dramaLabel;
        this.dramaName = res.data.data.drama.dramaName;
        this.dramaScore = res.data.data.drama.dramaScore;
        this.nickname = res.data.data.user.nickname;
        this.avatar = res.data.data.user.avatar;
        let starIcons = [];
        let intScore = Math.floor(this.dramaScore / 2);
        let hasHalf = this.dramaScore - intScore * 2 > 0;
        for (let i = 0; i < 5; i++) {
          if (i < intScore) {
            starIcons.push(StarLight);
          } else if (i === intScore) {
            if (hasHalf) {
              starIcons.push(StarHalf);
            } else {
              starIcons.push(StarGray);
            }
          } else {
            starIcons.push(StarGray);
          }
        }
        this.starIcons = starIcons;
      })
      .catch(res => {
        console.log(res);
      });
  },
  methods: {
    join() {
      this.baseUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan'
      if (this.isAndroid) {
        window.location.href = this.baseUrl + `&android_schema=${appUrlAndroid("210003", "wsdid=" + this.dramaid + "&wsrn=" + this.num)}`;
      } else if (this.isiOS) {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/QQ/i) == "qq") {
          this.isAppopen = true
        } else {
          window.location.href = appUrlIOS("210003", "wsdid=" + this.dramaid + "&scriptId=" + this.num + "&actionType=1");
        }
      } else {
        window.location.href = 'http://share.xiyacs.com/#/open'
      }
    }
  },
  mounted() { }
};
</script>
<style scoped>
.game_room {
  position: relative;
  width: 100%;
}

/* header */
.game_room .header {
  height: 9.35rem;
  justify-content: center;
}

.header_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 9.35rem;
  background: rgba(0, 0, 0, 0.3);
}

.game_room .header .bg_img {
  width: 100%;
  height: 9.35rem;
}

.game_room .header .bg_img img {
  width: 100%;
  height: 100%;
}

.game_room .header .bg_img .logo_image {
  position: absolute;
  top: 0.6rem;
  left: 6.4rem;
  width: 6rem;
  height: 2.295rem;
}

.game_room .header .bg_img .logo_image .logo {
  width: 100%;
  height: 100%;
}

.game_room .header .drama {
  position: absolute;
  top: 6.5rem;
  right: 0.2rem;
  height: 2.25rem;
}

.game_room .header .drama .subtitle {
  font-family: "PingFangSC-Regular";
  font-size: 0.625rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: right;
  width: 7.5rem;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.game_room .header .drama .infos {
  display: flex;
  justify-content: flex-end;
  text-align: right;
  font-size: 0.4rem;
}

.game_room .header .drama .infos .infos_stars {
  width: 6.3rem;
  height: 0.9rem;
  margin-top: 0.6rem;
  display: flex;
  justify-content: flex-end;
}

.game_room .header .drama .infos .stars {
  width: 0.9rem;
  height: 0.9rem;
  margin-left: 0.3rem;
}

.game_room .header .drama .infos .star {
  width: 100%;
  height: 100%;
}

.game_room .cover_img {
  width: 8rem;
  height: 8rem;
  position: absolute;
  top: 4.85rem;
  left: 0.6rem;
  z-index: 999;
  border-radius: 0.6rem;
  overflow: hidden;
}

.game_room .cover_img img {
  width: 100%;
  height: 100%;
}

.game_room .content_info {
  position: absolute;
  left: 0;
  top: 9.35rem;
}

.game_room .content_info .name {
  position: absolute;
  top: 0.6rem;
  left: 9.2rem;
  width: 7.5rem;
  height: 1.25rem;
}

.game_room .content_info .name p {
  font-family: "PingFangSC-Semibold";
  font-size: 0.9rem;
  color: #333336;
  letter-spacing: 0;
  text-align: left;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.game_room .content_info .room_num {
  width: 5.4rem;
  height: 1.35rem;
  position: absolute;
  left: 9.2rem;
  top: 2.15rem;
  background: #ffae29;
  border-radius: 0.15rem;
}

.game_room .content_info .room_num p {
  font-family: "PingFangSC-Semibold";
  font-size: 0.75rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  margin-top: 0.125rem;
}

.game_room .content_brief {
  width: 17.55rem;
  height: 10.05rem;
  position: absolute;
  left: 0.6rem;
  top: 14.05rem;
  /* 超出滚动条显示 */
  overflow: scroll;
}

.game_room .content_brief p {
  font-family: "PingFangSC-Regular";
  font-size: 0.75rem;
  color: #57565a;
  letter-spacing: 0;
  text-align: left;
  /* 省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* 第几行开始溢出点点点  */
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}

.game_room .avatar {
  position: absolute;
  top: 24.75rem;
  left: 8rem;
  width: 3rem;
  height: 3rem;
  border: 0.025rem solid #ccc;
  border-radius: 50%;
  overflow: hidden;
}

.game_room .avatar img {
  width: 100%;
  height: 100%;
}

.game_room .nick_name {
  width: 100%;
  position: absolute;
  top: 28.3rem;
  text-align: center;
  font-family: "PingFangSC-Regular";
  font-size: 0.75rem;
  color: #57565a;
  letter-spacing: 0;
}

.game_room .btn {
  width: 18.55rem;
  height: 3.4rem;
  position: relative;
  top: 21.2rem;
}

.game_room .btn_img {
  width: 100%;
  height: 100%;
}

.game_room .btns_bottom {
  width: 18.55rem;
  height: 3.4rem;
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0);
}

/* motai */
.modial {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  height: 33.35rem;
  background-size: cover;
}

.modial .modial_in {
  padding-left: 0.375rem;
  text-align: left;
  position: absolute;
  background: rgb(255, 255, 255);
  width: 8.75rem;
  height: 7.5rem;
  left: 50%;
  bottom: 50%;
  transform: translateX(-50%);
  border-radius: 0.5rem;
}

.modial .modial_in .title {
  font-weight: bold;
}

.modial .modial_in p {
  font-size: 0.75rem;
  margin-top: 0.5rem;
  color: black;
}

.modial .modial_in .room {
  font-size: 1rem;
}

.modial .modial_in .room {
  font-size: 1rem;
}

/* http://localhost:8080/invitegameroom?num=10010&dramaId=9cbz2TBNmwKVCKdXVJh&id=10086 */
</style>






// WEBPACK FOOTER //
// src/components/Invitegameroom.vue